import { Component, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Objects } from 'src/modules/utils/shared/objects';
import { EnaioProjectDocument } from '../../netgen/EnaioProjectDocument';

@Component({
  selector: 'app-project-documents',
    standalone: false,
    templateUrl: './project-documents.component.html',
  styleUrl: './project-documents.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProjectDocumentsComponent extends ComponentView {

    changeDetectorRef = inject(ChangeDetectorRef);
    
    neededParams: ObjectOfSimpleDataTypes = { projectNumber: "string" };
    projectNumber = "";

    docs: EnaioProjectDocument[];
    selectedDocument: EnaioProjectDocument = null;
    table: TableData;
    pdfSrc: Blob | string = "";
    
    async initParams(): Promise<boolean> {
        this.docs = await RestEndpoint.main().query({ projectNumber: this.projectNumber }).run("api/projectplanning/enaioProjectDocument").list(EnaioProjectDocument);
        this.table = new TableData([
            new TableColumn("objectType", this.app.t("ProjectPlanning.type"), TableCellType.string, 20),
            new TableColumn("type", this.app.t("ProjectPlanning.documentType"), TableCellType.string, 20),
            new TableColumn("title", this.app.t("ProjectPlanning.title"), TableCellType.string, 50),
            new TableColumn("documentNumber", this.app.t("ProjectPlanning.documentNumber"), TableCellType.string, 50),
            new TableColumn("date", this.app.t("ProjectPlanning.date"), TableCellType.date, 1)
        ], this.docs.map(doc => new TableRow(Objects.toString(doc.id), doc, doc)), 
            ["type", "title"]);
        return true;
    }

    async rowSelect(event): Promise<void> {
        const selectedDocument = event?.raw as EnaioProjectDocument;
        this.selectedDocument = selectedDocument;
        if (selectedDocument == null) {
            this.pdfSrc = "";
        }
        else {
            const pdfSrc = await RestEndpoint.main().query({ projectNumber: this.projectNumber, id: selectedDocument.id }).runBlob("api/projectplanning/enaioProjectDocument");
            if (this.selectedDocument == selectedDocument) {
                this.pdfSrc = pdfSrc;
                this.changeDetectorRef.detectChanges();
            }
        }
    }
}
